import script from "./HeyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeyButton.vue?vue&type=script&setup=true&lang=ts"

import "./HeyButton.vue?vue&type=style&index=0&id=712271d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712271d2"]])

export default __exports__